import { PanelHeaderCombinedProps } from './types';

const usePresenter = (props: PanelHeaderCombinedProps): PanelHeaderCombinedProps => {
  return props;
};

export default usePresenter;
